"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import "../util/auth";
export default {
  ignore: function(documentBatchId, reason) {
    return ApiService.addErrorHandler(
      $.post("/api/imports/document_batches/" + documentBatchId + "/ignore", { reason }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  ignoreAsDuplicate: function(documentBatchId, carrierInvoiceId) {
    return ApiService.addErrorHandler(
      $.ajax({
        url: "/api/carrier_invoice_duplicates/ignore",
        type: "PUT",
        data: {
          document_batch_id: documentBatchId,
          carrier_invoice_id: carrierInvoiceId
        }
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  setCarrier: function(documentBatchId, isSingleCarrier, carrierId, contact) {
    return ApiService.addErrorHandler(
      $.ajax({
        url: "/api/imports/document_batches/" + documentBatchId,
        type: "PUT",
        contentType: "application/json",
        data: JSON.stringify({
          document_batch: {
            carrier_id: carrierId,
            single_carrier: isSingleCarrier
          },
          contact
        })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  updateGroups: function(documentBatchId, documentGroups, originalIds) {
    return ApiService.addErrorHandler(
      $.ajax({
        url: "/api/imports/document_batches/" + documentBatchId + "/update_document_groups",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          originalIds,
          document_groups: documentGroups
        })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  markInvoicesIndexedAndSendTransmission: function(documentBatchId) {
    return ApiService.addErrorHandler(
      $.post("/api/document_batches/" + documentBatchId + "/mark_factor_invoices_indexed").then(DataStoreService.responseHandler, _.identity)
    );
  }
};
